import { useSearchParams } from "react-router-dom";

import useMeetingFeedback from "@app/analytics/MeetingReport/hooks/useMeetingFeedback";
import type {
  MeetingFeedbackResponse,
  MeetingFeedbackSelection,
} from "@app/analytics/types";

import FeedbackSnackbar from "./FeedbackSnackbar";

const getResponseFromParam = (
  feedback: MeetingFeedbackSelection | null
): MeetingFeedbackResponse | undefined => {
  if (!feedback) return;
  return feedback === "yes" ? "positive" : "negative";
};

const MeetingReportFeedback = () => {
  const [queryParams] = useSearchParams();

  const { myFeedback, submitFeedback } = useMeetingFeedback();

  const preselectedFeedback = queryParams.get(
    "meetingFeedback"
  ) as MeetingFeedbackSelection | null;

  const currentResponse = myFeedback.data?.feedback;

  if (myFeedback.isLoading && preselectedFeedback == null) return null;

  return (
    <FeedbackSnackbar
      currentResponse={currentResponse}
      onSubmit={submitFeedback}
      preselectedResponse={getResponseFromParam(preselectedFeedback)}
    />
  );
};

export default MeetingReportFeedback;
